import { render, staticRenderFns } from "./registerSmartfit.vue?vue&type=template&id=55303380"
import script from "./registerSmartfit.vue?vue&type=script&lang=js"
export * from "./registerSmartfit.vue?vue&type=script&lang=js"
import style0 from "./registerSmartfit.vue?vue&type=style&index=0&id=55303380&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports